// extracted by mini-css-extract-plugin
export default {"section":"NewYear_section__9cKpg","container":"NewYear_container__4JKDi","container__photo":"NewYear_container__photo__2zxeG","photo":"NewYear_photo__ZHv3N"};